import { ISBStory } from '@shared/types/storyblok';

/*
 * Recreates the standard data structure of a nested story that has been returned
 * as a result of 'resolve_relations` to match how it would be returned if
 * fetched directly on its own.
 */
export const normaliseResolvedStory = <T>(story: ISBStory<T>) => {
  const { content, ...rest } = story;
  return {
    content,
    _meta: rest,
  };
};
